import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import AuthShell from "@/components/AuthShell";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (!res.ok) { setError(res.error); return; }
    toast.success("Welcome back");
    navigate(res.user.role === "organizer" ? "/organizer/dashboard" : "/vendor/dashboard");
  };

  return (
    <AuthShell
      eyebrow="Welcome back"
      title="Log in."
      subtitle={<>New here? <Link to="/register" data-testid="login-to-register" className="underline">Create an account</Link></>}
      footer={<>By signing in you agree to our terms and privacy policy.</>}
    >
      <form onSubmit={onSubmit} className="space-y-6">
        <div>
          <Label htmlFor="email" className="text-xs uppercase tracking-widest">Email</Label>
          <Input id="email" data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-2" />
        </div>
        <div>
          <Label htmlFor="password" className="text-xs uppercase tracking-widest">Password</Label>
          <Input id="password" data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-2" />
          <div className="mt-2 text-right">
            <Link to="/forgot-password" data-testid="login-forgot-password" className="text-xs underline" style={{ color: "var(--ink-soft)" }}>
              Forgot password?
            </Link>
          </div>
        </div>
        {error && <div data-testid="login-error" className="text-sm" style={{ color: "var(--terracotta)" }}>{error}</div>}
        <Button type="submit" data-testid="login-submit" disabled={busy} className="btn-primary w-full py-6 rounded-full">
          {busy ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </AuthShell>
  );
}
